export default "__VITE_ASSET__q$__cWyV__"